var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"offset-xl":"3","col":"","xl":"6"}},[_c('b-table',{staticClass:"catalog-table",attrs:{"id":"catalog-table","bordered":"","small":"","no-border-collapse":"","responsive":"lg","primary-key":"id","items":_vm.items}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }